// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25O3I","rootNoMargin":"styles_rootNoMargin__1Alai"};